import React, { useState, useRef, useEffect } from 'react';

const CountryCodeDropdown = ({ value, onChange, options, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const selectedOption = options.find(option => option.value === value) || options.find(option => option.value === '+91') || options[0];

  const filteredOptions = options.filter(option => 
    option.country.toLowerCase().includes(searchQuery.toLowerCase()) ||
    option.code.includes(searchQuery) ||
    option.value.includes(searchQuery)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
    setSearchQuery('');
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full h-full px-3 py-2 bg-gray-50/50 hover:bg-gray-100 border-r rounded-lg text-sm font-medium text-gray-700 transition-colors focus:outline-none rounded-l-lg"
      >
        <span className="truncate font-mono">{selectedOption?.code}</span>
        <svg
          className={`w-3 h-3 ml-1.5 transition-transform duration-200 ${isOpen ? 'rotate-180 text-[rgb(var(--primary))]' : 'text-gray-500'}`}
          fill="none" stroke="currentColor" viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-200 rounded-lg shadow-xl w-44 overflow-hidden animate-in fade-in zoom-in-95 duration-100">
          <div className="p-2 border-b border-gray-200 bg-white sticky top-0 z-10">
            <div className="relative">
              <svg className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" strokeWidth="2"/>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                ref={searchInputRef}
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search..."
                className="w-full pl-9 pr-3 py-2 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[rgb(var(--primary))]/20 focus:border-[rgb(var(--primary))]"
              />
            </div>
          </div>
          
          <div className="max-h-52 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <button
                  key={option.value + option.country}
                  type="button"
                  onClick={() => handleSelect(option)}
                  className={`w-full px-4 py-2.5 text-left transition-colors border-b border-gray-50 last:border-0 ${
                    selectedOption?.value === option.value && selectedOption?.country === option.country
                      ? 'bg-[rgb(var(--primary))]/5 text-[rgb(var(--primary))] font-semibold'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium capitalize truncate pr-2">{option.country}</span>
                    <span className="text-xs font-mono opacity-80">{option.code}</span>
                  </div>
                </button>
              ))
            ) : (
              <div className="px-4 py-6 text-center text-xs text-gray-500">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryCodeDropdown;